const techStackFront = [
  {
    name: 'HTML',
    img: './icons8-html-5-96.png'
  },
  {
    name: 'CSS',
    img: './icons8-css3-96.png'
  },
  {
    name: 'JavaScript',
    img: './icons8-javascript-96.png'
  },
  {
    name: 'React',
    img: './icons8-react-80.png'
  },
  {
    name: 'TypeScript',
    img: './icons8-typescript-96.png'
  },
  {
    name: 'Bootstrap',
    img: './icons8-bootstrap-96.png'
  },
  {
    name: 'Tailwind',
    img: './tailwind.png'
  },
]

const techStackBack = [
  {
    name: 'MongoDb',
    img: './icons8-mongodb-96.png'
  },
  {
    name: 'PostgreSQL',
    img: './icons8-postgresql-96.png'
  },
  {
    name: 'Node.js',
    img: './icons8-node-js-96.png'
  },
  {
    name: 'Mongoose',
    img: './icons8-mongoose-96.png'
  },
  {
    name: 'Sequilize',
    img: './sequelize-96.png'
  },
  {
    name: 'Express.js',
    img: './icons8-express-js-96.png'
  },
  {
    name: 'RESTful API',
    img: './icons8-rest-api-96.png'
  },
  {
    name: 'Git',
    img: './icons8-git-96.png'
  },
  {
    name: 'Postman',
    img: './postman.png'
  },
  {
    name: 'Python',
    img: './icons8-python-96.png'
  },

]

export {
  techStackFront, 
  techStackBack
}